export default {
    en: {
        ALL_RIGHTS_RESERVED: 'Armis Inc. All Rights Reserved.',
        CONTACT_LINK_HREF_SUBJECT: 'Intelligence Center - looking for details',
        CONTACT_LINK_TEXT: 'contact us',
        DOCUMENTATION_LINK_TEXT: 'documentation',
        EMAIL: 'Email',
        ERROR: 'Something went wrong',
        FILL_EMAIL: "Please fill your email address and we'll send you a login link",
        RETRY: 'or click again to retry',
        SEND: 'Send login link',
        SENDING: 'Sending login link…',
        SENT: 'Sent, please check your inbox',
        TRY_LATER: 'Please try again later',
        WELCOME: 'Welcome to the Intelligence Center',
    },
};
